import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PHOTO_PICKER_MODEL } from '../../../../components/PhotoPicker/SubComponent/Models/Models';
import { useDispatch, useSelector } from 'react-redux';
import { Updatedelivery } from '../../../../reduxToolkit/EquipmentAndMaterial/EquipmentApi';
import { toast } from 'react-toastify';
import { uploadDeliveryAsset } from '../EquipmentAndMaterial/Functionality/CommonsEquipmentAndMaterial';
import { CLOSE_DELIVERY_MODEL, DELIVERY_ASSET_TYPE } from '../EquipmentAndMaterial/Model/Model';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const MarkAsCompletedModalApp = (props) => {
    const { equipment, onHide, setMarkAsCompleted, onCompleted } = props;

    const userId = useSelector((state) => state.authenticatioauthennSlice.getUserByIdAtEntry.userId);
    const { t } = useTranslation();
    const delivery = useSelector((state) => state.equipmentSlice.getDeliveryById.data.data);

    // Local state for the photo picker component.
    // Initializes using PHOTO_PICKER_MODEL defaults and ensures name/file are safely set.
    const [photoPicker, setPhotoPicker] = useState({ ...PHOTO_PICKER_MODEL });
    // Controls whether empty field warnings should be displayed.
    const [emptyFields, setEmptyFields] = useState(false);
    // Stores the user's comment input.
    const [comment, setComment] = useState('');
    // Redux dispatcher
    const dispatch = useDispatch();
    const [displayModal, setDisplayModal] = useState("");
    // Controls modal visibility (placeholder function).
    const handleComplete = () => {
        // Check if the comment is empty
        if (!comment || (!photoPicker?.fileSelected && !photoPicker?.selfieSrc)) {
            setEmptyFields(true);
            toast.warn(t('please_fill_all_fields'));
            return;
        }

        const closeDeliveryModel = CLOSE_DELIVERY_MODEL.toRegister({
            delivery,
            equipment,
            userId,
            comment
        });

        dispatch(Updatedelivery(closeDeliveryModel.set())).then(
            ({
                payload: {
                    data: { success}
                }
             }) => {
                if (success === true && photoPicker) {
                    uploadDeliveryAsset({
                        deliveryId: delivery.id,
                        photoPicker,
                        uploadType: DELIVERY_ASSET_TYPE.CLOSED,
                        dispatch
                    }).then(
                        ({
                            payload: {
                                data: { success}
                            }
                         }) => {
                            if (success === true) {
                                toast.success(t('has_been_completed_successfully'));
                                onHide();
                                onCompleted();
                                setMarkAsCompleted(true);
                            }
                        }
                    );
                }
            }
        );
    };

    return {
        t,
        emptyFields,
        comment,
        setComment,
        photoPicker,
        setPhotoPicker,
        handleComplete,
        displayModal,
        setDisplayModal
    };
};

export default MarkAsCompletedModalApp;
